import request from '@/utils/request';
import { getToken } from '@/utils/auth';
import ENVIRONMENT from '@/utils/environment';
// 获取资源列表
export function getMrdeskResourceList(params) {
  return request({
    url: `/device/lots`,
    method: 'get',
    params
  });
}
// 创建课桌设备批次管理信息
export function getMrdeskResourceAdd(params) {
  return request({
    url: `/device/lotdetails`,
    method: 'post',
    params
  });
}
// 获取设备批次明细模板
export function getMrdeskResourceDefautExport() {
  return `${ENVIRONMENT.BASE_API}/device/lotdetails/template?token=${getToken()}`;
}
// 设备批次明细导入
export function getMrdeskResourceDefautImport() {
  return `${ENVIRONMENT.BASE_API}/device/lotdetails/import`;
}
// 导出地址参数处理
function exportUrl(options, apiUrl) {
  let url = '';
  url = `${ENVIRONMENT.BASE_API}${apiUrl}?`;
  for (var key in options) {
    if (options[key]) { url += `${key}=${options[key]}&`; }
  }
  url = url.substring(0, url.lastIndexOf('&'));
  return url + `&token=${getToken()}`;
}
// 获取资源导出
export function exportExcelMrdeskResource(options) {
  return exportUrl(options, '/device/lotdetails/export');
}
// 获取资源详情
export function getMrdeskResourceDetails(params) {
  return request({
    url: `/device/lotdetails`,
    method: 'get',
    params
  });
}
// 停用设备批次明细
export function getMrdeskResourceDetailsDisable(data) {
  return request({
    url: `/device/lotdetails/disable`,
    method: 'put',
    data
  });
}
// 启用设备批次明细
export function getMrdeskResourceDetailsEnable(data) {
  return request({
    url: `/device/lotdetails/enable`,
    method: 'put',
    data
  });
}

// 查询课桌设备管理分页列表
export function getDeviceLotsList(data) {
  return request({
    url: `/device/lots`,
    method: 'get',
    params: data
  });
}

// 创建课桌设备管理批次
export function createDeviceLotsInfo(data) {
  return request({
    url: `/device/lots`,
    method: 'post',
    data
  });
}

// 修改课桌设备管理批次
export function updateDeviceLotsInfo(lotId, data) {
  return request({
    url: `/device/lots/${lotId}`,
    method: 'put',
    data
  });
}

// 删除课桌设备管理批次
export function deleteDeviceLotsInfo(lotId) {
  return request({
    url: `/device/lots/${lotId}`,
    method: 'delete'
  });
}

// 查询课桌设备批次管理明细分页列表
export function getDeviceLotdetailsList(data) {
  return request({
    url: `/device/lotdetails`,
    method: 'get',
    params: data
  });
}

